import * as _ from 'lodash';

const recursivelyRemoveProp = (obj: any, propName: string) => {
    for (const prop in obj) {
        if (prop === propName) {
            delete obj[prop];
        } else if (obj[prop] !== null && typeof obj[prop] === 'object') {
            recursivelyRemoveProp(obj[prop], propName);
        }
    }
    return obj;
};

const omit = (data: any, omitProps: any = []) => {
    const clonedData = _.cloneDeep(data);
    const cleanedData = recursivelyRemoveProp(clonedData, '__typename');
    return _.omit(cleanedData, omitProps) as any;
};

export default omit;
